import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { ContentType } from '@entries/content-types'
import ContentfulFootnoteSup from '@entries/contentful-footnote-sup'
import { withDisplayName } from '@hocs/with-display-name'
import { paragraphTextSecondary } from '@render-node/paragraph-text-secondary'
import { documentHeading3 } from '@render-node/refresh-document-heading-3'
import { children } from '@render-node/utils/children'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { CtaLink } from '@ui/cta-link'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulContentArticleRefreshPictoRightLeft: Utils.EntryFC<
  Queries.ContentfulContentArticleRefreshPictoRightLeftFragment
> = ({
  content: {
    contentArticleTitle: title,
    subtitle,
    contentLinkText,
    contentLinkUrl,
  },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div
    className="w-full px-2 pb-8 pt-4 tablet:py-10"
    {...entryInspectorProps()}
  >
    <div className="pb-0 pt-2">
      <RichText
        {...fieldInspectorProps({
          fieldId: 'title',
        })}
        content={title}
        options={{
          ...defaultRichTextFieldOptionsDeprecated,
          renderNode: {
            ...defaultRichTextFieldOptionsDeprecated.renderNode,
            [BLOCKS.DOCUMENT]: documentHeading3,
            [BLOCKS.HEADING_3]: children,
            [BLOCKS.PARAGRAPH]: children,
          },
        }}
      />
    </div>
    <div className="pb-9 pt-1">
      <RichText
        {...fieldInspectorProps({
          fieldId: 'subtitle',
        })}
        content={subtitle}
        options={{
          renderNode: {
            [BLOCKS.PARAGRAPH]: paragraphTextSecondary,
            [INLINES.EMBEDDED_ENTRY]: {
              [ContentType.ContentfulFootnote]: ContentfulFootnoteSup,
            },
          },
        }}
      />
    </div>
    <CtaLink
      data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
      data-type={ENHANCED_COMPONENT_TYPE.CTA}
      href={contentLinkUrl}
      {...fieldInspectorProps({
        fieldId: 'contentLinkText',
      })}
    >
      {contentLinkText}
    </CtaLink>
  </div>
)

export const query = graphql`
  fragment ContentfulContentArticleRefreshPictoRightLeft on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    contentArticleTitle: title {
      ...ContentfulContentArticleTitle
    }
    subtitle {
      ...ContentfulContentArticleSubtitle
    }
    contentLinkText
    contentLinkUrl
  }
`

export default withDisplayName(
  ContentfulContentArticleRefreshPictoRightLeft,
  'ContentfulContentArticleRefreshPictoRightLeft'
)
